module.exports = __webpack_public_path__ + "static/media/checkavailable.0d42f3f3.png";